import { TASK_FIELDS } from '../../../../utils/formFields/task';
import { TASK_STATUS, TASK_TYPE } from '../../../../utils/constants/task';
import { patrolFormFields } from '../../../../utils/patrol';
import { siteFields } from '../../../../utils/SiteFormFields';
import { PAGE_NAME } from 'utils/constants';
import { GEOGRAPHICAL_MAP } from 'utils/constants/Map';
import { GenericColumns } from '../Generic/Columns';

export const CleaningColumns = [...GenericColumns];

export const defaultValues = {
  taskType: TASK_TYPE.CLEANING.id,
  isTemplate: false,
  wrapsId: null,
  scanCode: null,
  scanAutoStart: null,
  scanStartOnly: null,
  surfaceViewPreferred: true,
  status: TASK_STATUS.NEW.id,
  siteSurfaceImages: GEOGRAPHICAL_MAP,
};

export const generalSection = ({
  sites = [],
  newSite,
  countries,
  languages,
  addContact,
  businessClients = [],
  addBusinessClient,
  clients = [],
  selectedBusinessClient,
  addSiteContact,
  toggleManageVisitor,
  isMobilePatrolOnly,
  timezones,
  hasVisitorManagement,
}) => {
  return [
    TASK_FIELDS.name,
    TASK_FIELDS.taskType({
      options: [TASK_TYPE.CLEANING],
    }),
    TASK_FIELDS.assignee({
      view: PAGE_NAME.CLEANER_OPERATIONAL,
    }),
    patrolFormFields.site({
      options: sites.map(site => ({
        ...site,
        id: site.id,
        name: `(${site.siteId}) ${site.businessClientName} - ${site.siteName}`,
      })),
      required: false,
      disabled: newSite,
      hidden: isMobilePatrolOnly,
    }),
    patrolFormFields.newSite(),
    siteFields.siteEmbeddedPanel({
      newSite,
      countries,
      languages,
      addContact,
      businessClients,
      addBusinessClient,
      clients,
      selectedBusinessClient,
      addSiteContact,
      toggleManageVisitor,
      timezones,
      hasVisitorManagement,
    }),
  ];
};

export const detailedSection = ({ siteLocations }) => {
  return [
    TASK_FIELDS.description(),
    TASK_FIELDS.startTime(),
    TASK_FIELDS.endTime(),
    TASK_FIELDS.expectedDuration(),
    TASK_FIELDS.evidenceRequired(),
    TASK_FIELDS.location({
      view: TASK_TYPE.CLEANING.name,
      siteLocations,
    }),
  ];
};
